export default class WipActionItems {
    wipActionItemId: number;
    wipTicketId: number;
    wipActionItemShift: string;
    wipActionItemDate: string | Date | null;
    wipActionCompletedBy: string;
    skidNo: string;
    location: string;
    quantity: number;
    qiHold: number;

    constructor(){
        this.wipActionItemId = 0;
        this.wipTicketId = 0;
        this.wipActionItemShift = "";
        this.wipActionItemDate = "";
        this.wipActionCompletedBy = "";
        this.skidNo = "";
        this.location = "";
        this.quantity = 0;
        this.qiHold = 0;
    }
}